import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import Modal from '../components/Modal';
import api from '../hooks/api';

export default function DeviceTypesPage() {
  const { user } = useAuth();
  const [types, setTypes] = useState([]);
  const [modal, setModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setTypes(await api.get('/api/device-types'));
  }, []);

  useEffect(() => { load(); }, [load]);

  function openAdd() { setName(''); setEditId(null); setError(''); setModal(true); }

  function openEdit(t) { setName(t.name); setEditId(t.id); setError(''); setModal(true); }

  async function handleSave(e) {
    e.preventDefault(); setError('');
    try {
      if (editId) await api.put('/api/device-types/' + editId, { name });
      else await api.post('/api/device-types', { name });
      setModal(false); load();
    } catch (err) { setError(err.message); }
  }

  async function handleDelete(t) {
    if (!window.confirm(`Delete device type "${t.name}"? This will fail if any devices use it.`)) return;
    try { await api.delete('/api/device-types/' + t.id); load(); }
    catch (err) { alert(err.message); }
  }

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title" style={{ margin: 0 }}>Device Types</h1>
        {(user?.role === 'admin' || user?.role === 'manager') &&
          <button className="btn btn-primary" onClick={openAdd}>+ Add Type</button>}
      </div>
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr><th>Name</th><th>Created</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {types.map(t => (
              <tr key={t.id}>
                <td style={{ fontWeight: 600 }}><span className="tag">{t.name}</span></td>
                <td>{t.created_at ? new Date(t.created_at).toLocaleDateString() : '—'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {(user?.role === 'admin' || user?.role === 'manager') &&
                    <button className="btn btn-ghost btn-sm" onClick={() => openEdit(t)}>Edit</button>}
                  {user?.role === 'admin' &&
                    <button className="btn btn-danger btn-sm" style={{ marginLeft: 6 }} onClick={() => handleDelete(t)}>Delete</button>}
                </td>
              </tr>
            ))}
            {types.length === 0 && <tr><td colSpan={3} className="empty">No device types yet</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={editId ? 'Edit Device Type' : 'Add Device Type'} onClose={() => setModal(false)}>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSave}>
            <div className="form-group">
              <label>Name *</label>
              <input value={name} onChange={e => setName(e.target.value)} required autoFocus placeholder="e.g. Laptop" />
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-ghost" onClick={() => setModal(false)}>Cancel</button>
              <button type="submit" className="btn btn-primary">{editId ? 'Save Changes' : 'Add Type'}</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}
